import { render } from "./FullscreenMessage.vue?vue&type=template&id=aa0736a2&scoped=true"
import script from "./FullscreenMessage.vue?vue&type=script&lang=js"
export * from "./FullscreenMessage.vue?vue&type=script&lang=js"

import "./FullscreenMessage.vue?vue&type=style&index=0&id=aa0736a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa0736a2"]])

export default __exports__